module.exports = __webpack_public_path__ + "img/index-solutions-sim.e406c785.png";